import React, { useEffect, useState } from 'react';

import { CommentContainer, CommentBox } from './styles.LatestComments';

export const LatestComments: React.FC = () => {
  type Comment = {
    id: string;
    text: string;
    timestamp: string;
  };

  const [error, setError] = useState(null);
  const [items, setItems] = useState([]);

  useEffect(() => {
    fetch('https://wtwm-topic-modelling.brdata-dev.de/v1/get_latest_mentions', {
      method: 'GET',
      headers: {
        Authorization:
          'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoiYnJkYXRhYWlsYWIiLCJleHBpcmVzIjoxNzAwOTE5NzExLjkxNjd9.LuLuLYHXHYuK4Y50SOW-hgEfAPpdR2Uc331C7vXVtVU',
      },
    })
      .then((res) => res.json())
      .then(
        ({ result }) => {
          setItems(result);
        },
        (error) => {
          setError(error);
        }
      );
  }, []);

  return (
    <>
      <CommentContainer>
        {error && (
          <p>
            <em>Error: Could not load comments</em>
          </p>
        )}
        {items &&
          items.map((comment: Comment) => (
            <CommentBox key={comment.id}>
              <p className="timeStamp">
                {new Date(comment.timestamp).toLocaleDateString('en', {
                  weekday: 'long',
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                })}
              </p>
              <p className="comment">{comment.text}</p>
            </CommentBox>
          ))}
      </CommentContainer>
    </>
  );
};
